(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aquapulse-product-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.aqp-variant-select')) return;
    var form = event.target.closest('[data-aqp-product]');
    if (!form) return;
    var selected = event.target.options[event.target.selectedIndex];
    var price = selected && selected.getAttribute('data-price');
    var priceTarget = form.querySelector('.aqp-price-value');
    if (priceTarget && price) priceTarget.textContent = price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
